import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { FC } from 'react';
import { Development } from '~/api/types';
import { DevelopmentRow } from '~/components/button/development-row';
import { colors } from '~/theme';

export const DevelopmentSelectionButton: FC<DevelopmentSelectionButtonProps> = ({
  development,
  onClickWhenUrlIsNull,
  disabled,
  badgeLabel,
}) => {
  const { customerPortalUrl } = development;

  const onClick = () => {
    // nothing can be done with a disabled development, not even opening its
    // portal
    if (disabled) return;

    if (customerPortalUrl === null) {
      onClickWhenUrlIsNull();
    } else {
      window.open(customerPortalUrl, '_blank')?.focus();
    }
  };

  return (
    <DevelopmentRow
      development={development}
      disabled={disabled}
      badgeLabel={badgeLabel}
      onClick={onClick}
      trailing={<ChevronRightIcon sx={{ color: disabled ? colors.disabledGray : colors.darkGray2 }} />}
    />
  );
};

export interface DevelopmentSelectionButtonProps {
  development: Development;
  onClickWhenUrlIsNull: () => void;
  disabled?: boolean;
  badgeLabel?: string;
}
